import { useSelector } from "react-redux"

export const useBusinessAccountId = () => {
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const { admin_selected_business_account_id } = useSelector((state) => state.user)
  const business_account_id = isAdmin
    ? admin_selected_business_account_id
    : userInfo?.current_business_account_id

  return business_account_id
}
